export default "__VITE_ASSET__DosvCTeR__"